import React from 'react';
import './ModalSistema.css';

function ModalAlert({ open, onClose, title = 'Aviso', message, labelOk = 'OK' }) {
  if (!open) return null;
  return (
    <div className="modal-sistema-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-alert-title">
      <div className="modal-sistema-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <h5 className="modal-sistema-title mb-2" id="modal-alert-title">{title}</h5>
        <p className="modal-sistema-message text-muted small mb-3">{message}</p>
        <div className="d-flex justify-content-end">
          <button type="button" className="btn btn-primary btn-sm" onClick={onClose}>{labelOk}</button>
        </div>
      </div>
    </div>
  );
}

export default ModalAlert;
